import { render, staticRenderFns } from "./UpList.vue?vue&type=template&id=1fdd559b&scoped=true&"
import script from "./UpList.vue?vue&type=script&lang=js&"
export * from "./UpList.vue?vue&type=script&lang=js&"
import style0 from "./UpList.vue?vue&type=style&index=0&id=1fdd559b&lang=scss&scoped=true&"
import style1 from "./UpList.vue?vue&type=style&index=1&id=1fdd559b&lang=scss&scoped=true&"
import style2 from "./UpList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdd559b",
  null
  
)

component.options.__file = "UpList.vue"
export default component.exports